<template>
	<div class="home">
		<van-nav-bar
		  	title="主页">
			<van-icon name="./static/img/mine.png" slot="right" @click="$router.push('/Center')" style="font-size: 26px;color: #000;"/>
		</van-nav-bar>
		<div class="menuList">
	  		<div class="menuItem" @click="$router.push('/ShopList')">
	  			<div class="menuTitle">
	  				店铺
	  			</div>
	  			<div class="menuIcon">
	  				<van-image
					  	width="40"
					  	height="40"
					  	src="./static/img/cr_Shop.png"
					/>
	  			</div>
	  		</div>
	  	
	  		<div class="menuItem" @click="$router.push('/')">
	  			<div class="menuTitle">
	  				账单
	  			</div>
	  			<div class="menuIcon">
	  				<van-image
					  width="40"
					  height="40"
					  src="./static/img/Bill.png"
					/>
	  			</div>
	  		</div>
		</div>
		  
	</div>
</template>

<script>
export default {
    data () {
      	return {
      		
      	}
    },
    mounted:function(){
    	
    },
    methods:{
    	

		
		
    }
}
</script>
<style scoped>
	.home{
		width: 100%;
		height: 100vh;
	}
	.menuList{
		width: 100%;
		height: 100px;
		margin-top: 20px;
		display: flex;
	}
	.menuItem{
		width: 50%;
		height: 100px;
		background: #fff;
		margin-left: 20px;
		border-radius: 3px;
		overflow: hidden;
	}
	.menuItem:nth-child(2){
		margin-right: 20px;
	}
	.menuTitle{
		width: 100%;
		height: 27px;
		line-height: 27px;
		font-size: 15px;
		text-align: center;
	}
	.menuIcon{
		width: 100%;
		height: 73px;
		line-height: 73px;
		background: #FFB20D;
		display: flex;
		align-items: center;
		justify-content: center;
	}
</style>



// WEBPACK FOOTER //
// src/components/Home.vue